import { gql } from '@apollo/client'

export const AUDIT_INVENTORY_ITEM_FRAGMENT = gql`
  fragment AuditInventoryItem on AuditInventoryItem {
    __typename
    id
    upc
    quantity
    facingsQuantity
  }
`
